<template>

    <div class="select-container">
        <select :placeholder="field.title" :id="'sel2_' + field.key" v-model="value" ref="selectField">
            <option :value="null" disabled selected hidden> {{ field.title }}</option>
            <option
                v-for="option in list"
                :key="option.key"
                :value="option.value"> {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>


export default {
    name : "InputDropdown",

}
</script>

<script setup>

import { watch, ref, computed, onMounted } from "vue";
import { getValue, getList }               from "../composables/useData";
import { useStore }                        from "vuex";


let props       = defineProps( [ "field", "data", "datastore" ] );
let emits       = defineEmits( [ "update", 'clearErrors' ] )
let store       = useStore();
let value       = ref( getValue( props.field, store.state, "user.profile" ) );
let selectField = ref( null );

let list = computed( () => getList( props.field, props.data, props.datastore ) );


//watch (value, () => emits("update", {key: props.field.key, value: value.value}) )

// let isChecked = computed(() = {
//     if(value.value)
// })

function mounted ()
{

    let selectOptions = {
        minimumResultsForSearch : Infinity,
        placeholder             : props.field.title.value,
        width                   : 'resolve',
    };

    /**
     * Kludge until we can select default values for all fields
     * @type {*|jQuery|HTMLElement}
     */
    if ( props.field.key.startsWith( 'animal-type-' ) )
    {

        // console.log( ' value.value', value.value, value )
        selectOptions.placeholder = '';
        if ( value.value === '' || value.value === null )
        {
            value.value = 0;
        }
    }


    const $sel    = $( "#sel2_" + props.field.key );
    const $parent = $sel.parent();

    selectOptions.dropdownParent = $parent;

    if ( props.field.key.startsWith( 'animal-type-' ) )
    {
        selectField.value.style.width = "100px";
    } else {

        selectField.value.style.width = (selectField.value.clientWidth + 30) + "px";
    }

    setTimeout( () =>
    {


        $sel
            .select2( selectOptions )
            .on( 'change.select2', ( e ) =>
            {

                let key   = props.field.key;
                let value = e.currentTarget.value

                emits( 'update', { key, value } );
                emits( 'clearErrors' );


            } );

    }, 100 );
}

onMounted( mounted );

function hasField ( fields )
{
    let strKey = props.field.key;

    return fields.includes( strKey );
}

function getKey ()
{
    return props.field.key;
}

defineExpose( { hasField, getKey } );

</script>

